module.exports = __webpack_public_path__ + "files/96e56f82b51ce105df254a820638a4e2.png";